import React, { useEffect, type ReactNode } from 'react'
import styles from './utopiaLanding.module.css'

export type UtopiaBottomSheetModalProps = {
  active: boolean
  onClose: () => void
  title: string
  titleId: string
  subtitle?: string
  meta?: string
  wide?: boolean
  children: ReactNode
}

export default function UtopiaBottomSheetModal ({
  active,
  onClose,
  title,
  titleId,
  subtitle,
  meta,
  wide = false,
  children,
}: UtopiaBottomSheetModalProps) {
  useEffect(() => {
    if (!active) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [active, onClose])

  if (!active) return null

  return (
    <>
      <button
        type="button"
        className={styles.navAuthDropdownBackdrop}
        aria-label="Fermer"
        tabIndex={-1}
        onClick={onClose}
      />
      <div
        className={`${styles.navAuthDropdown} ${wide ? styles.navAuthDropdownWide : ''}`}
        role="dialog"
        aria-modal
        aria-labelledby={titleId}
      >
        <div className={styles.navAuthDropdownHeader}>
          <div className={styles.navAuthDropdownHeaderText}>
            <h2 id={titleId} className={styles.navAuthDropdownTitle}>
              {title}
            </h2>
            {subtitle && (
              <p className={styles.navAuthDropdownSubtitle}>{subtitle}</p>
            )}
            {meta && (
              <p className={styles.navAuthDropdownMeta}>{meta}</p>
            )}
          </div>
          <button
            type="button"
            className={styles.navAuthDropdownClose}
            onClick={onClose}
            aria-label="Fermer"
          >
            ×
          </button>
        </div>
        <div
          className={styles.navAuthDropdownBody}
          onWheel={e => e.stopPropagation()}
        >
          {children}
        </div>
        <div className={styles.navAuthDropdownFooter}>
          <button type="button" className={styles.authSubmit} onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </>
  )
}
